import { Component, Input } from "@angular/core";
import { BonusService } from "src/app/services/bonus/bonus.service";
import { Navigator } from 'src/app/services/routing/navigator';
import { ConfigService } from "src/app/services/config/config.service";
import { IPromotion } from "src/app/interfaces/player-dashboard.interface";
import { PopoverController } from "@ionic/angular";
import { RoutingService } from "src/app/services/routing/routing.service";

@Component({
    selector: 'app-popover-promotion-details',
    templateUrl: './popover-promotion-details.component.html',
    styleUrls: ['./popover-promotion-details.component.scss'],
})
export class PromotionDetailsPopoverComponent {
    @Input() data: IPromotion;

    public get promotion(): IPromotion {
        return this.data;
    }

    constructor(
        private bonusService: BonusService,
        private config: ConfigService,
        private navigator: Navigator,
        private popOverCtrl: PopoverController,
        private routing: RoutingService,
    ) { }

    public moreInfo() {
        this.bonusService.setPromoDetailInfo({ id: this.promotion.id });
        this.navigator.dismissAll('');
        this.routing.toPromotionsTab();
    }

    public closePopover() {
        try {
            this.navigator.activePopovers[this.navigator.activePopovers.length - 1].dismiss();
        } catch (e) {
            console.log("Popover Close Error", e)
            this.popOverCtrl.dismiss();
        }
    }
}